import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import GlobalStyle from "./styles/GlobalStyle";
import { theme } from "./styles/theme";
import LoginPage from "./pages/Auth/Login";
import SignupPage from "./pages/Auth/Signup";
import ResetPasswordPage from "./pages/Auth/ResetPassword";
import ForgotPasswordPage from "./pages/Auth/ForgotPassword";
import DashboardLayout from "./components/layout/DashboardLayout";
import Notification from "./components/shared/Notification";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import { setLoading, setUser } from "./store/slices/authSlice";
import { SearchProvider } from "./context/SearchContext";
import InactivityTimer from "./components/InactivityTimer";
import { resumeAllPendingJobs } from "./utils/download-handler.js";

const App = () => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const isLoggedIn = useSelector((state) => state.auth.loggedIn);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(setUser());
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  // Resume any pending download jobs when user is logged in
  useEffect(() => {
    if (isLoggedIn) {
      resumeAllPendingJobs(
        (downloadUrl, filename, jobId) => {
          console.log(`Download ready for job ${jobId}: ${filename}`);
          // Optionally show a notification or trigger download
          showNotification(`Download ready: ${filename}`, "success");
        },
        (error, jobId) => {
          console.error(`Download failed for job ${jobId}:`, error);
          showNotification(`Download failed: ${error}`, "error");
        },
        (count) => {
          if (count > 0) {
            console.log(`Resuming ${count} pending download job(s)`);
          }
        }
      );
    }
  }, [isLoggedIn]);

  const showNotification = (message, severity) => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const handleClose = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  if (auth.loading) {
    return <div>Loading...</div>;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <StyledComponentsThemeProvider theme={theme}>
        <GlobalStyle />
        <SearchProvider>
          <Router>
            {isLoggedIn && <InactivityTimer />}
            <Routes>
              <Route
                path="/login"
                element={
                  !auth.loading ? (
                    <LoginPage showNotification={showNotification} />
                  ) : (
                    <div>Loading...</div>
                  )
                }
              />
              <Route
                path="/signup"
                element={
                  !auth.loading ? (
                    <SignupPage showNotification={showNotification} />
                  ) : (
                    <div>Loading...</div>
                  )
                }
              />
                <Route
                path="/reset-password"
                element={
                  !auth.loading ? (
                    <ResetPasswordPage showNotification={showNotification} />
                  ) : (
                    <div>Loading...</div>
                  )
                }
              />
              <Route
                path="/forgot-password"
                element={
                  !auth.loading ? (
                    <ForgotPasswordPage showNotification={showNotification} />
                  ) : (
                    <div>Loading...</div>
                  )
                }
              />
              <Route element={<ProtectedRoute />}>
                {/* <Route
                  path="/dashboard/*"
                  element={
                    <DashboardLayout>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="groups" element={<Groups />} />
                        <Route
                          path="components"
                          element={<VisualComponents />}
                        />
                      </Routes>
                    </DashboardLayout>
                  }
                /> */}
                <Route path="/dashboard/*" element={<DashboardLayout />} />
              </Route>
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
            <Notification
              open={notification.open}
              message={notification.message}
              severity={notification.severity}
              handleClose={handleClose}
            />
          </Router>
        </SearchProvider>
      </StyledComponentsThemeProvider>
    </MuiThemeProvider>
  );
};

export default App;
